import { render } from "./ScheduleSendModals.vue?vue&type=template&id=07935aaa&scoped=true"
import script from "./ScheduleSendModals.vue?vue&type=script&lang=js"
export * from "./ScheduleSendModals.vue?vue&type=script&lang=js"

import "./ScheduleSendModals.vue?vue&type=style&index=0&id=07935aaa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-07935aaa"

export default script